import { IQuestionModel } from '@care-portals/api-interfaces';

const options = [
  { key: '0', value: 'Did not apply to me at all' },
  { key: '1', value: 'Applied to me to some degree, or some of the time' },
  {
    key: '2',
    value: 'Applied to me to a considerable degree or a good part of time'
  },
  { key: '3', value: 'Applied to me very much or most of the time' }
];

const questions = [
  'I found it hard to wind down',
  'I was aware of dryness of my mouth',
  'I couldn’t seem to experience any positive feeling at all',
  'I experienced breathing difficulty (e.g.excessively rapid breathing, breathlessness in the absence of physical exertion)',
  'I found it difficult to work up the initiative to do things',
  'I tended to over-react to situations',
  'I experienced trembling (e.g.in the hands)',
  'I felt that I was using a lot of nervous energy',
  'I was worried about situations in which I might panic and make a fool of myself',
  'I felt that I had nothing to look forward to',
  'I found myself getting agitated',
  'I found it difficult to relax',
  'I felt down-hearted and blue',
  'I was intolerant of anything that kept me from getting on with what I was doing',
  'I felt I was close to panic',
  'I was unable to become enthusiastic about anything',
  'I felt I wasn’t worth much as a person',
  'I felt that I was rather touchy',
  'I was aware of the action of my heart in the absence of physical exertion (e.g.sense of heart rate increase, heart missing a beat)',
  'I felt scared without any good reason',
  'I felt that life was meaningless'
];

const questionsModels: IQuestionModel[] = [
  {
    field: 'dass21_intro',
    type: 'info',
    label:
      'Please read each statement and choose the answer which indicates how much the statement applied to you over the past week.There are no right or wrong answers.Do not spend too much time on any statement.',
    answer: {}
  },
  ...questions.map(
    (q, i) =>
      ({
        field: `dass21_${i + 1}`,
        label: q,
        type: 'select',
        answer: {
          type: 'single_select',
          options
        }
      } as IQuestionModel)
  )
];

export default questionsModels;
